import React, { useState } from "react";
import styles from "./tabs.module.css";

const TwoTabs = ({ defaultActiveKey, tabs, className, tabClassname }) => {
	const [activeTab, setActiveTab] = useState(defaultActiveKey);

	return (
		<div className={`${styles.tabsContainer} ${className}`}>
			<div className={`${tabClassname} tabsHeader`}>
				{tabs.map(({ eventKey, title, tabClassName }) => (
					<button
						key={eventKey}
						className={`tabButton ${
							activeTab === eventKey ? "active" : ""
						} ${tabClassName}`}
						onClick={() => setActiveTab(eventKey)}>
						{title}
					</button>
				))}
			</div>
			<div className="tabsContent">
				{tabs.map(
					({ eventKey, content }) =>
						activeTab === eventKey && (
							<div key={eventKey} className="tabContent">
								{content}
							</div>
						)
				)}
			</div>
		</div>
	);
};

export default TwoTabs;
